import { css } from '@emotion/react'
import { memo } from 'react'
import useMedia from '~/hooks/useMedia'
import { fill_horizontal_cross_center } from '~/modules/AppLayout/FlexGridCss'
import { UserAvatarAsDialogButton } from '~/modules/auth/components/UserAvatarAsDialogButton'
import { ChartingServerSwitch } from '~/modules/SDK/chart4/components/ChartingServerSwitch'
import { Preset_Topbar } from '../heineken_template/_preset/preset_Topbar'
import { store } from '../heineken_template/_private/store'

export const Big3Stock_Topbar = memo<ReactProps>(function Big3Stock_Topbar() {
  const { isPc } = useMedia()

  return (
    <div
      css={css`
        ${fill_horizontal_cross_center};
        justify-content: end;
        background: linear-gradient(157deg, #323b60, #1c305e);
      `}
    >
      {isPc && <ChartingServerSwitch charting={store.charting} />}
      {isPc && <UserAvatarAsDialogButton />}
      {!isPc && (
        <Preset_Topbar
          showLeftBurger
          showRightBurger
          componentsInRight={
            <div
              css={css`
                ${fill_horizontal_cross_center};
                justify-content: end;
                background: linear-gradient(157deg, #323b60, #1c305e);
              `}
            >
              <ChartingServerSwitch charting={store.charting} />
              <UserAvatarAsDialogButton />
            </div>
          }
        ></Preset_Topbar>
      )}
    </div>
  )
})
